import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './views/login/login.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PanelModule } from 'primeng/panel';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { ListboxModule } from 'primeng/listbox';
import { CheckboxModule } from 'primeng/checkbox';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import {CardModule} from 'primeng/card';
import { ToastModule } from 'primeng/toast';
import { PasswordModule } from 'primeng/password';

const routes:Routes = [
  {
    path: '*',
    redirectTo: '', 
  },
  {
    path: '', 
    redirectTo: 'login', 
    pathMatch: 'full'
  }, 
  {
    path: 'login',
    component: LoginComponent
  }
];

@NgModule({
  declarations: [
    LoginComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    PanelModule,
    InputTextModule,
    TextareaModule,
    DropdownModule,
    ButtonModule,
    ListboxModule,
    CheckboxModule,
    BreadcrumbModule,
    CardModule,
    ToastModule,
  ],
  exports: [
    RouterModule,
  ],
  providers: [
  ]
})
export class SessionModule { }
